import TrainingCategory from '../category';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingCategory.store(({ trainingId, categoryId }, fetch) => {
    // Prepare request
    let formData = new FormData();
    formData.append('category_id', categoryId);

    return fetch.post(`/trainings/${trainingId}/categories`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
